// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e0825e67","453":"f9460aca","455":"3ee1200b","977":"7294515a"}[chunkId] + ".chunk.js";
};